module.exports = __webpack_public_path__ + "img/jacket-left-sub-raglan-hood.0fc7d862.png";